module.exports = {
  accountTypes: {
    ssii: 1,
    freelance: 2,
    do: 4
  },
  colors: {
    blue: '#104182'
  },
  progessi: {
    work_effort_item_status: {
      wei_in_process: {
        value: 'wei_in_process',
        text: 'En cours'
      },
      wei_closed: {
        value: 'wei_closed',
        text: 'Terminé'
      },
      wei_opened: {
        value: 'wei_opened',
        text: 'A venir'
      },
    }
  },
  sites: {
    fr: {
      languages: ['fr', 'fr-FR'],
      port: 8947,
      url: process.env.URL_FR,
      redirectionMessage: 'Twineeds est également disponible en France',
    },
    ca: {
      languages: ['fr-CA'],
      port: 8947,
      url: process.env.URL_CA,
      redirectionMessage: 'Twineeds est maintenant disponible au Canada !',
    }
  },
  languageLevels: {
    beginner: {value: 1, label: 'Notion'},
    medium: {value: 2, label: 'Moyen'},
    good: {value: 3, label: 'Bon niveau'},
    fluent: {value: 4, label: 'Courant'},
    native: {value: 5, label: 'Bilingue ou langue maternelle'},
  },
}
